/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {DeleteUserApiKeyRequest} from '@cash-web/protos/squareup/cash/kgoose/api/v2/cred_service.pb'
import {DeleteUserApiKeyResponse} from '@cash-web/protos/squareup/cash/kgoose/api/v2/cred_service.pb'


export const deleteUserApiKey = (request: DeleteUserApiKeyRequest, options?: CashRequestOptions) => post<DeleteUserApiKeyRequest, DeleteUserApiKeyResponse>("/2.0/cash/delete-user-api-key", request, {...options, rejectOnError: true })